export const LABELS = {
  all: 'All',
  general_info: 'General Info',
  banner: 'Banner',
  first_lead: 'First Lead',
  icons: 'Icons',
  icon: 'Icon',
  features: 'Features',
  intro: 'Intro',
  hotpoints: 'Hotpoints',
  video_functions: 'Video',
  second_lead: 'Second Lead',
  functions: 'Functions',
  dimensions: 'Dimensions',
  summary: 'Summary',
  comparison: 'Comparison',
  /** Right-rail timeline when the comparison slot is Cross-selling (e.g. Schneider `ComparisonCustomSection`) */
  cross_selling: 'Cross-selling',
  photos: 'Photos',
  /** Haier2 card template — Photos section in product form. */
  visualisations: 'Visualisations',
  /** Legacy label; prefer {@link visualisations} for Haier2. */
  photos_visualisation: 'Photos / Visualisation',
  accessories: 'Accessories',
  attributes: 'Attributes',
  icon_functions: 'Icon Functions',
  download_button: 'Download Button',
  link_button: 'Link Button',
  action_icon: 'Action Icon',
  video: 'Video',
  navigation: 'Navigation',
  product_box: 'Product Box',
  lead: 'Lead',
  slider: 'Slider',
  footer: 'Footer',
  backgrounds: 'Backgrounds',
  logo: 'Logo',
  dimensions_accessories: 'Dimensions Accessories',
}
